import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import { ArrayUtil, ObjectUtil, StringUtil } from 'src/utils';

interface ContactListItemDTO {
  id: string;
  contactName: string;
  contactType: string;
  affiliation: string;
  phone: string;
  email: string;
}
const ContactListItemDTO = {
  create: (initValues?: Partial<ContactListItemDTO>): ContactListItemDTO => {
    const defaults: ContactListItemDTO = {
      id: '',
      contactName: '',
      contactType: '',
      affiliation: '',
      phone: '',
      email: '',
    };
    const fixedInitValues: Partial<ContactListItemDTO> = initValues != null
      ? {
        id: StringUtil.IsNullOrEmpty(initValues.id) ? uuidv4() : initValues.id,
      }
      : {};
    return { ...defaults, ...initValues, ...fixedInitValues };
  },
};

export default ContactListItemDTO;
